// @flow
import i18n from "../../../i18n";

export const isSameAs = (otherValue: any) => (value: any, values: Dict) => {
  return value === values[otherValue] ? undefined : i18n.t("validation:isSame");
};
